export default __webpack_public_path__ + "0a4588656a79be22cb6eb6ad08d74654.svg";